import { useContext, useEffect, useState } from 'react'

// others
import { Category, PaginationPayload, useFetchAllCategoriesLazyQuery } from '../../generated'
import { GRAPHQL_QUERY_POLICY, QUERY_PARAMS } from '../constants'
import { AppContext } from '../context'
import { ActionType } from '../context/AppContextReducer'
import { useDebounce } from 'use-debounce'
import { useSearchParams } from 'react-router-dom'

export const useCategories = ({ fetchCategory = true }: { fetchCategory?: boolean }) => {
  const [categories, setCategories] = useState<Category[]>([])
  const [pagination, setPagination] = useState<PaginationPayload | null>({})
  const { currentPage, searchValue, dispatch: reducerDispatch } = useContext(AppContext)
  const [searchParams] = useSearchParams()
  const queryParam = searchParams.get(QUERY_PARAMS.QUERY)
  const [debouncedValue] = useDebounce(searchValue || queryParam, 500)

  const [fetchAllCategories, { loading, refetch }] = useFetchAllCategoriesLazyQuery({
    ...GRAPHQL_QUERY_POLICY,
    variables: undefined,
    onError() {
      setCategories([])
      reducerDispatch({ type: ActionType.SET_IS_LOADING, isLoading: false })
    },
    onCompleted(data) {
      if (data) {
        const { fetchAllCategories } = data
        const { categories, pagination = {} } = fetchAllCategories
        setPagination(pagination)
        if (categories) setCategories(categories.filter((category): category is Category => category !== null))
      }
    }
  })

  useEffect(() => {
    fetchCategory &&
      fetchAllCategories({
        variables: {
          fetchCategoriesInput: {
            keyword: debouncedValue,
            paginationOptions: {
              limit: 100,
              page: currentPage
            }
          }
        }
      })
  }, [currentPage, fetchAllCategories, debouncedValue, fetchCategory])

  return { categories, pagination, loading, refetch }
}
